import { useStore } from "@/store";
import { Features } from "@/types/features";
import { observer } from "mobx-react-lite";
import { FunctionComponent, ReactElement } from "react";
import { Link } from "react-router-dom";
import { ReactComponent as LogoSvg } from "./_assets/logo.svg";

export const MobileHeader: FunctionComponent = observer((): ReactElement => {
  const store = useStore();

  return (
    <div className="mobileHeader">
      <div className="mobileHeaderLogo">
        <Link to="/">
          <LogoSvg />
        </Link>
        {false && <input type="checkbox" className="toggle-button switchMob" />}
      </div>
      <div>
        {false && (
          <ul className="btnGroupHorizontal">
            <li className="btnGroupHorizontalLi">
              <a className="mainBtn" onClick={store.popup.togglePromote}>
                Скачать
              </a>
            </li>
            {!store.profile.pro &&
              store.profile.isFeatureEnabled([Features.Pro.Purchase]) && (
                <li className="btnGroupHorizontalLi">
                  <a className="secondBtn" onClick={store.popup.togglePro}>
                    PRO
                  </a>
                </li>
              )}
          </ul>
        )}
      </div>
    </div>
  );
});
